import { Component, HostBinding, Input } from '@angular/core'
import { BehaviorSubject, combineLatest, Observable, timer } from 'rxjs'
import { debounce, distinctUntilChanged, map } from 'rxjs/operators'

@Component({
    selector: 'mg-ui-loading-container,[mg-ui-loading-container]',
    templateUrl: './ui-loading-container.component.html',
    styleUrls: ['./ui-loading-container.component.scss'],
})
export class UiLoadingContainerComponent {
    isLoading$: BehaviorSubject<boolean> = new BehaviorSubject(false)
    isUpdating$: BehaviorSubject<boolean> = new BehaviorSubject(false)

    @Input()
    loaderShowDelay: number = 400
    showLoader$: Observable<boolean>

    /**
     * Minimum amount of time (ms) to debounce before showing the loading-screen
     */
    private minimumLoaderShowDelay = 5

    constructor() {
        this.showLoader$ = combineLatest(this.isLoading$, this.isUpdating$).pipe(
            distinctUntilChanged(),
            map<boolean[], boolean>(loadingStates => loadingStates.some(loadingState => loadingState === true)),
            debounce(isLoading =>
                isLoading === true
                    ? timer(Math.max(this.loaderShowDelay, this.minimumLoaderShowDelay))
                    : timer(this.minimumLoaderShowDelay)
            )
        )
    }

    @HostBinding('class.isLoading')
    @Input()
    get isLoading(): boolean {
        return this.isLoading$.getValue()
    }

    set isLoading(value: boolean) {
        this.isLoading$.next(value)
    }

    @HostBinding('class.isUpdating')
    @Input()
    get isUpdating(): boolean {
        return this.isUpdating$.getValue()
    }

    set isUpdating(value: boolean) {
        this.isUpdating$.next(value)
    }
}
